import { render } from "./MediaDocsLinksPanel.vue?vue&type=template&id=5f1e1434&scoped=true"
import script from "./MediaDocsLinksPanel.vue?vue&type=script&lang=js"
export * from "./MediaDocsLinksPanel.vue?vue&type=script&lang=js"

import "./MediaDocsLinksPanel.vue?vue&type=style&index=0&id=5f1e1434&lang=scss&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f1e1434"]])

export default __exports__